import { useWorkspace } from "./useWorkspace.ts";

export const useWorkspaceLogos = () => {
  const { workspace } = useWorkspace();

  return workspace.brands.filter((brand) => brand.type === "LOGO");
};
